// extracted by mini-css-extract-plugin
module.exports = {"RoundSummary":"RoundSummary_RoundSummary__1As5q","Selections":"RoundSummary_Selections__8_qyV","NameGroup":"RoundSummary_NameGroup__2bM3B"};